import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { contentFieldSx } from "../../content/contentEditorStyles";
import { toDatetimeLocal } from "../../../../utils/newsletterDateUtils";

export const SCHEDULE_NOW = "now";
export const SCHEDULE_LATER = "scheduled";

const minScheduledDatetime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 5);
  return toDatetimeLocal(now.toISOString());
};

const NewsletterScheduleSection = ({
  scheduleMode,
  onScheduleModeChange,
  scheduledAt,
  onScheduledAtChange,
  scheduledAtError,
}) => {
  const hasError = Boolean(scheduledAtError);

  return (
    <FormControl component="fieldset" error={hasError}>
      <FormLabel component="legend" sx={{ fontWeight: 600, color: "#334155", mb: 1, fontSize: "0.875rem" }}>
        Quando inviare
      </FormLabel>
      <RadioGroup value={scheduleMode} onChange={(e) => onScheduleModeChange(e.target.value)}>
        <FormControlLabel value={SCHEDULE_NOW} control={<Radio />} label="Invia subito" />
        <FormControlLabel value={SCHEDULE_LATER} control={<Radio />} label="Programma invio" />
      </RadioGroup>
      {scheduleMode === SCHEDULE_LATER ? (
        <Stack spacing={0.75} sx={{ mt: 1, maxWidth: 360 }}>
          <TextField
            type="datetime-local"
            label="Data e ora programmazione"
            value={scheduledAt}
            onChange={(e) => onScheduledAtChange(e.target.value)}
            slotProps={{ inputLabel: { shrink: true } }}
            inputProps={{ min: minScheduledDatetime(), step: 60 }}
            fullWidth
            error={hasError}
            sx={contentFieldSx}
          />
          {scheduledAtError ? (
            <FormHelperText sx={{ mx: 0 }}>{scheduledAtError}</FormHelperText>
          ) : (
            <FormHelperText sx={{ mx: 0 }}>
              Usa il selettore per impostare data e ora di invio.
            </FormHelperText>
          )}
        </Stack>
      ) : null}
    </FormControl>
  );
};

NewsletterScheduleSection.propTypes = {
  scheduleMode: PropTypes.oneOf([SCHEDULE_NOW, SCHEDULE_LATER]).isRequired,
  onScheduleModeChange: PropTypes.func.isRequired,
  scheduledAt: PropTypes.string,
  onScheduledAtChange: PropTypes.func.isRequired,
  scheduledAtError: PropTypes.string,
};

export default NewsletterScheduleSection;
